import { useDashboardStats } from "@/hooks";
import PageHeader from "@/components/shared/PageHeader";
import KpiCard from "@/components/shared/KpiCard";
import { FitossanitarioChart, RiscoChart } from "./components/StatusChart";
import { EspeciesChart, MonthlyTrend } from "./components/EspeciesChart";
import MapaOperacional from "./components/MapaOperacional";
import AlertasPrioritarios from "./components/AlertasPrioritarios";
import InteligenciaUrbana from "./components/InteligenciaUrbana";
import VistoriasTable from "./components/VistoriasTable";
import RecentProjects from "./components/RecentProjects";

export default function Dashboard() {
  const { stats } = useDashboardStats();

  return (
    <div className="space-y-6">
      <PageHeader
        title="Dashboard FloraIQ"
        subtitle={`Inteligência ambiental urbana para gestão do CTA, áreas verdes e carbono · Atualizado em ${new Date().toLocaleDateString("pt-BR")}`}
      >
        <button className="btn-outline text-xs px-3 py-2 cursor-pointer">
          <i className="ri-upload-cloud-line"></i>
          <span className="hidden sm:inline">Importar Dados</span>
        </button>
        <button className="btn-primary text-xs px-3 py-2 cursor-pointer">
          <i className="ri-add-line"></i>
          <span className="hidden sm:inline">Novo Projeto</span>
        </button>
      </PageHeader>

      {/* KPI Grid - 8 cards usando KpiCard compartilhado */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
        <KpiCard label="Árvores Cadastradas" value={stats.totalArvores} icon="ri-plant-line" variant="success" trend={{ value: "+12 este mês", positive: true }} />
        <KpiCard label="Vistorias Realizadas" value={stats.vistoriasTotal} icon="ri-clipboard-line" variant="info" trend={{ value: "+48 este mês", positive: true }} />
        <KpiCard label="Risco Crítico" value={stats.arvoresRiscoCritico} icon="ri-error-warning-line" variant="danger" />
        <KpiCard label="CO₂e Estimado" value={`${stats.co2eEstimado} t`} icon="ri-leaf-line" variant="success" />
        <KpiCard label="Projetos Ativos" value={stats.projetosAtivos} icon="ri-folder-chart-line" variant="info" />
        <KpiCard label="Espécies Identificadas" value={stats.especiesIdentificadas} icon="ri-search-line" variant="default" />
        <KpiCard label="Áreas Verdes" value={stats.areasVerdes} icon="ri-landscape-line" variant="success" />
        <KpiCard label="Pendências" value={stats.vistoriasPendentes} icon="ri-timer-line" variant="warning" />
      </div>

      {/* Charts Row 1 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <FitossanitarioChart />
        <RiscoChart />
      </div>

      {/* Charts Row 2 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <EspeciesChart />
        <MonthlyTrend />
      </div>

      {/* Mapa Operacional */}
      <MapaOperacional />

      {/* Alertas + Inteligência Urbana */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <AlertasPrioritarios />
        <InteligenciaUrbana />
      </div>

      {/* Vistorias Table */}
      <VistoriasTable />

      {/* Projetos Recentes */}
      <RecentProjects />
    </div>
  );
}